/**
 * TerminalNode — the START and END sinks of a workflow graph.
 *
 * The engine's serialize() derives these from the entry point + the 'END' route
 * sentinel (BPMN / LangGraph `__start__`/`__end__` convention) so every graph
 * shows where flow enters and terminates. Rendered as a small rounded pill,
 * visually distinct from the action (WorkflowNode) and decision (DecisionNode)
 * boxes. Carries both a top target + bottom source handle so edges connect
 * regardless of which terminal it is.
 */
import { Handle, Position } from 'reactflow';
import { IonIcon } from '@ionic/react';
import { playOutline, flagOutline } from 'ionicons/icons';
import './TerminalNode.css';

export const TerminalNode = ({ data, isConnectable }) => {
  const variant = data?.terminal === 'start' ? 'start' : 'end';
  const label = data?.label || (variant === 'start' ? 'Start' : 'End');
  // Distinct shapes: a play triangle to GO, a finish flag to END.
  const icon = variant === 'start' ? playOutline : flagOutline;

  return (
    <div className={`gwe-terminal-node gwe-terminal-node--${variant}`}>
      <Handle type="target" position={Position.Top} id="top" isConnectable={isConnectable} className="gwe-terminal-node__handle" />
      <span className="gwe-terminal-node__dot">
        <IonIcon icon={icon} />
      </span>
      <span className="gwe-terminal-node__label">{label}</span>
      <Handle type="source" position={Position.Bottom} id="bottom" isConnectable={isConnectable} className="gwe-terminal-node__handle" />
    </div>
  );
};

export default TerminalNode;
